/**
 * @file
 * Swiper slider.
 */
(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.swiperSliderReviews = {
    attach: function (context, settings) {
      let swiper = new Swiper(".swiper-reviews", {
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          }
        }
      });
    }
  };

})(jQuery, Drupal);
